// pages/Services.js
import React from "react";
import Header from "../components/home/Header";

import Footer from "../components/home/Footer";
import DevelopmentServie from "../components/ourwork/DevelopmentService";
import CallToAction from "../components/ourwork/CallToActionSection";
function DevelopmentServicePage() {
  return (
    <div>
      <Header />
      <DevelopmentServie />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default DevelopmentServicePage;
